import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import { take, debounceTime, map } from 'rxjs/operators';
import { ZMP_G2G_BFF_ENDPOINT_URL } from '@ztarmobile/zwp-service';
import * as i1 from '@ztarmobile/zwp-services-auth';
import * as i1$1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { serverTimestamp } from 'firebase/database';
import * as i2 from '@angular/fire/compat/database';
import * as i3 from 'ngx-device-detector';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ReplaySubject } from 'rxjs';
import * as i2$1 from '@angular/platform-browser';
import { v4 } from 'uuid';
import kountSDK from '@kount/kount-web-client-sdk';

class CatalogCoreService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
        this.CATALOG_V1_URL = `${this.endpointUrl}/v1/catalog`;
        this.CONTENTFUL_CATALOG_URL = `${this.endpointUrl}/v1/contentfulCatalog`;
    }
    /**
     * a method to get all plans of a specific environment (test, stage, prod)
     * @returns all plans items'
     */
    getCatalogPlan(intent, zipCode) {
        return new Promise((resolve, reject) => {
            let queryParams = `intent=${intent}`;
            if (!!zipCode) {
                queryParams = queryParams + `&zipCode=${zipCode}`;
            }
            this.http.get(`${this.CATALOG_V1_URL}/plans?${queryParams}`).pipe(take(1)).subscribe((plansCatalog) => {
                resolve(plansCatalog);
            }, (error) => reject(error));
        });
    }
    clearCache(key) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.endpointUrl}/v1/general/cache/${key}`).pipe(take(1)).subscribe(() => {
                resolve();
            }, (error) => reject(error));
        });
    }
    getAcpDeviceBySkuFromContentful(sku) {
        const endpoint = `${this.CONTENTFUL_CATALOG_URL}/acpDeviceBySku?sku=${!!sku ? sku : ''}`;
        return new Promise((resolve, reject) => {
            this.http.get(endpoint)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getAcpDevicesFromContentful() {
        const endpoint = `${this.CONTENTFUL_CATALOG_URL}/acpDevices`;
        return new Promise((resolve, reject) => {
            this.http.get(endpoint)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CatalogCoreService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CatalogCoreService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CatalogCoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class EbbService {
    constructor(endpointUrl, http, angularFireDatabase, deviceService) {
        this.endpointUrl = endpointUrl;
        this.http = http;
        this.angularFireDatabase = angularFireDatabase;
        this.deviceService = deviceService;
    }
    verifyEBB(data, recaptchaResponse) {
        const header = new HttpHeaders().set('reCaptcha', recaptchaResponse);
        return new Promise((resolve, reject) => {
            this.http.postWithHeaderWithoutCredentials(`${this.endpointUrl}/v1/ebb/verify`, data, header)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    verifyACP(data, recaptchaResponse) {
        const header = new HttpHeaders().set('reCaptcha', recaptchaResponse);
        return new Promise((resolve, reject) => {
            this.http.postWithHeaderWithoutCredentials(`${this.endpointUrl}/v2/ebb/verify`, { ...data, command: 'CreateNewACPCommand' }, header)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getCodes(state) {
        const endpoint = !state ? `${this.endpointUrl}/v1/ebb/eligibility-codes` : `${this.endpointUrl}/v1/ebb/eligibility-codes?state=${state}`;
        return new Promise((resolve, reject) => {
            this.http.get(`${endpoint}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getVerifiedDetails(ebbId) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/acp/verify/${ebbId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getACPVerifiedDetails(appId, callbackUrl) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v2/ebb/verify/${appId}?callbackUrl=${callbackUrl}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getACPApplicationStatus(ebbId, customerId, callbackUrl) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/acp/${ebbId}?customerId=${customerId}&callbackUrl=${callbackUrl}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getUserDetails(ebbId) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/ebb/${ebbId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    sign(signData) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.endpointUrl}/v1/ebb/sign`, signData)
                .pipe(take(1)).subscribe((result) => resolve(), (error) => reject(error));
        });
    }
    getDeviceEligibility(ebbId) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/acp/${ebbId}/device/eligibility/check`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getACPDeviceDetails(ebbId, customerId) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/acp/${ebbId}/devices?customerId=${customerId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    logVerifyError(userId, error) {
        const timeNow = new Date();
        const dateString = (new DatePipe('en-US')).transform(timeNow, 'yyyy-MM-dd');
        const errorObject = {
            createdAt: serverTimestamp(),
            location: window.location.href,
            datetime: timeNow.toUTCString(),
            message: error || 'NO MESSAGE Found!',
            agent: this.deviceService.getDeviceInfo()
        };
        const errorPath = `/xLogs/ebb/date-${dateString}/${userId || '-unknown'}`;
        this.angularFireDatabase.object(errorPath).update(errorObject)
            .then(() => {
            console.debug('Error logged successfully');
        }).catch((err) => {
            console.error('Could not log error ', err);
        });
    }
    deleteEbbData(userId) {
        const path = `/usersData/ebb/${userId}`;
        this.angularFireDatabase.object(path).remove()
            .then(() => {
            console.debug('EBB data removed successfully');
        }).catch((err) => {
            console.error('Could not remove EBB data', err);
        });
    }
    createInternalApplication(data) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.endpointUrl}/v2/ebb/application`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getActiveInternalApplication(customerId) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v2/ebb/application?customerId=${customerId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getInternalApplication(customerId, appOrEbbId) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v2/ebb/application/${appOrEbbId}?customerId=${customerId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    verifyACPWithOrWithoutAppId(data, recaptchaResponse, action, invisibleRecaptcha) {
        let header = new HttpHeaders()
            .set('reCaptcha', recaptchaResponse);
        if (!!action) {
            header = header.set('action', action);
        }
        header = header.set('invisibleRecaptcha', `${!!invisibleRecaptcha}`);
        return new Promise((resolve, reject) => {
            this.http.postWithHeaderWithoutCredentials(`${this.endpointUrl}/v1/acp`, data, header)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    verifyACPWithOrWithoutAppIdInternally(data) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.endpointUrl}/v1/acp/internal`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getPublicHousingPrograms() {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/acp/housing-programs`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    deleteAcpApplication(customerId, applicationId) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.endpointUrl}/v1/acp/${customerId}/${applicationId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EbbService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }, { token: i2.AngularFireDatabase }, { token: i3.DeviceDetectorService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EbbService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EbbService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }, { type: i2.AngularFireDatabase }, { type: i3.DeviceDetectorService }] });

class EquipmentService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
    }
    checkDeviceCompatibility(recaptchaResponse, equipmentId, zip, carrier) {
        if (!!recaptchaResponse) {
            const header = new HttpHeaders().set('reCaptcha', recaptchaResponse);
            return new Promise((resolve, reject) => {
                this.http.getWithOptions(`${this.endpointUrl}/v1/equipment/compatibility?equipment=${equipmentId}&zip=${zip}&carrier=${carrier}`, '', header)
                    .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
            });
        }
        else {
            return new Promise((resolve, reject) => {
                reject('Recaptcha validation is required');
            });
        }
    }
    checkCoverageCompatibility(recaptchaResponse, zip, equipment, isLte) {
        if (!!equipment) {
            const equipmentValue = `equipment=${equipment}`;
            return this.getBackendcheckCompatibilityWithEquipmentOrWithout(recaptchaResponse, zip, equipmentValue);
        }
        else if (!equipment && isLte !== null) {
            const lteValue = `isLte=${isLte}`;
            return this.getBackendcheckCompatibilityWithEquipmentOrWithout(recaptchaResponse, zip, lteValue);
        }
        else {
            return this.getBackendcheckCompatibilityWithEquipmentOrWithout(recaptchaResponse, zip);
        }
    }
    checkCodeValidity(recaptchaResponse, code) {
        if (!!recaptchaResponse) {
            const header = new HttpHeaders().set('reCaptcha', recaptchaResponse);
            return new Promise((resolve, reject) => {
                this.http.getWithOptions(`${this.endpointUrl}/v1/equipment/code/validate?code=${code}`, '', header)
                    .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
            });
        }
        else {
            return new Promise((resolve, reject) => {
                reject('Recaptcha validation is required');
            });
        }
    }
    checkDeviceCompatibilityByAddress(recaptchaResponse, zip, address1, city, state, address2, equipment) {
        if (!!recaptchaResponse) {
            const header = new HttpHeaders().set('reCaptcha', recaptchaResponse);
            let queryParams = `zip=${zip}&address1=${address1}&city=${city}&state=${state}`;
            if (!!address2) {
                queryParams = `${queryParams}&address2=${address2}`;
            }
            if (!!equipment) {
                queryParams = `${queryParams}&equipment=${equipment}`;
            }
            return new Promise((resolve, reject) => {
                this.http.getWithOptions(`${this.endpointUrl}/v1/equipment/coverage/check?${queryParams}`, '', header)
                    .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
            });
        }
        else {
            return new Promise((resolve, reject) => {
                reject('Recaptcha validation is required');
            });
        }
    }
    checkDeviceCompatibilityV2(recaptchaResponse, zip, address1, city, state, address2, equipment, action, invisibleRecaptcha) {
        if (!!recaptchaResponse) {
            let header = new HttpHeaders()
                .set('reCaptcha', recaptchaResponse);
            if (!!action) {
                header = header.set('action', action);
            }
            header = header.set('invisibleRecaptcha', `${!!invisibleRecaptcha}`);
            let queryParams = `zip=${zip}&address1=${address1}&city=${city}&state=${state}`;
            if (!!address2) {
                queryParams = `${queryParams}&address2=${address2}`;
            }
            if (!!equipment) {
                queryParams = `${queryParams}&equipment=${equipment}`;
            }
            return new Promise((resolve, reject) => {
                this.http.getWithOptions(`${this.endpointUrl}/v2/equipment/coverage/check?${queryParams}`, '', header)
                    .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
            });
        }
        else {
            return new Promise((resolve, reject) => {
                reject('Recaptcha validation is required');
            });
        }
    }
    checkNetworkCoverageByAddress(recaptchaResponse, zip, address1, city, state, address2, action, invisibleRecaptcha, idempotentKey) {
        if (!!recaptchaResponse) {
            let header = new HttpHeaders()
                .set('reCaptcha', recaptchaResponse);
            if (!!action) {
                header = header.set('action', action);
            }
            header = header.set('invisibleRecaptcha', `${!!invisibleRecaptcha}`);
            let queryParams = `zip=${zip}&address1=${address1}&city=${city}&state=${state}`;
            if (!!address2) {
                queryParams = `${queryParams}&address2=${address2}`;
            }
            if (!!idempotentKey) {
                queryParams += `&idempotentKey=${idempotentKey}`;
            }
            return new Promise((resolve, reject) => {
                this.http.getWithOptions(`${this.endpointUrl}/v1/wireless-services/coverages/address?${queryParams}`, '', header)
                    .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
            });
        }
        else {
            return new Promise((resolve, reject) => {
                reject('Recaptcha validation is required');
            });
        }
    }
    checkNetworkCoverageByImei(recaptchaResponse, zip, address1, city, state, imei, address2, hashKey, action, invisibleRecaptcha, idempotentKey) {
        if (!!recaptchaResponse) {
            let header = new HttpHeaders()
                .set('reCaptcha', recaptchaResponse);
            if (!!action) {
                header = header.set('action', action);
            }
            header = header.set('invisibleRecaptcha', `${!!invisibleRecaptcha}`);
            let queryParams = `zip=${zip}&address1=${address1}&city=${city}&state=${state}&imei=${imei}`;
            if (!!address2) {
                queryParams += `&address2=${address2}`;
            }
            if (!!hashKey) {
                queryParams += `&hashKey=${hashKey}`;
            }
            if (!!idempotentKey) {
                queryParams += `&idempotentKey=${idempotentKey}`;
            }
            return new Promise((resolve, reject) => {
                this.http.getWithOptions(`${this.endpointUrl}/v1/wireless-services/coverages/imei?${queryParams}`, '', header)
                    .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
            });
        }
        else {
            return new Promise((resolve, reject) => {
                reject('Recaptcha validation is required');
            });
        }
    }
    getBackendcheckCompatibilityWithEquipmentOrWithout(recaptchaResponse, zipCode, option) {
        if (!!recaptchaResponse) {
            const header = new HttpHeaders().set('reCaptcha', recaptchaResponse);
            return new Promise((resolve, reject) => {
                this.http.getWithOptions(`${this.endpointUrl}/v1/equipment/coverage?zip=${zipCode}&${option}`, '', header)
                    .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
            });
        }
        else {
            return new Promise((resolve, reject) => {
                reject('Recaptcha validation is required');
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EquipmentService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EquipmentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EquipmentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class NewsletterService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
    }
    // V1
    register(newsletterData, recaptchaResponse) {
        const header = new HttpHeaders().set('reCaptcha', recaptchaResponse);
        return new Promise((resolve, reject) => {
            this.http.postWithHeaderWithoutCredentials(`${this.endpointUrl}/v1/newsletter`, newsletterData, header)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    // V2
    subscribe(newsletterData, campaignId, recaptchaResponse, action, invisibleRecaptcha) {
        let header = new HttpHeaders()
            .set('reCaptcha', recaptchaResponse);
        if (!!action) {
            header = header.set('action', action);
        }
        header = header.set('invisibleRecaptcha', `${!!invisibleRecaptcha}`);
        return new Promise((resolve, reject) => {
            this.http.postWithHeaderWithoutCredentials(`${this.endpointUrl}/v2/newsletters/${campaignId}/subscribe`, newsletterData, header)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NewsletterService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NewsletterService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NewsletterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class ShipmentService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
    }
    validateShipmentAddress(data) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.endpointUrl}/v1/shipment/address/validate`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    estimateShipmentAddress(data) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.endpointUrl}/v1/shipment/estimate`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    trackingShipmentAddress(trackingNumber, carrier) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/shipment/tracking?trackingNumber=${trackingNumber}&carrier=${carrier}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/shipment/tracking`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ShipmentService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ShipmentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ShipmentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class SweepstakesService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
    }
    submitSweepstakesForm(sweepstakeId, sweepstakeData) {
        return new Promise((resolve, reject) => {
            this.http.postWithoutCredentials(`${this.endpointUrl}/v1/sweepstakes/${sweepstakeId}`, sweepstakeData)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    verifySweepstakes(sweepstakeId, verificationCode) {
        return new Promise((resolve, reject) => {
            this.http.getWithoutCredentials(`${this.endpointUrl}/v1/sweepstakes/${sweepstakeId}?verificationCode=${verificationCode}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SweepstakesService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SweepstakesService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SweepstakesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class UserAccountService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
    }
    enableWifiCalling(mdn, data) {
        return new Promise((resolve, reject) => {
            this.http.put(`${this.endpointUrl}/v1/account/${mdn}/wifi-calling`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    disableWifiCalling(mdn) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.endpointUrl}/v1/account/${mdn}/wifi-calling`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    cancelPendingFuturePlan(mdn) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.endpointUrl}/v1/account/${mdn}/cancel-pending-plan`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    changeAccountPin(mdn, pinCode) {
        return new Promise((resolve, reject) => {
            this.http.put(`${this.endpointUrl}/v1/account/${mdn}/change-pin`, { pin: pinCode })
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    updateDefaultPayment(mdn, data) {
        return new Promise((resolve, reject) => {
            this.http.put(`${this.endpointUrl}/v1/account/${mdn}/default-payment`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getMdnDetails(planId, mdn, searchType) {
        if (!!searchType) {
            return new Promise((resolve, reject) => {
                this.http.get(`${this.endpointUrl}/v1/account/${planId}/mdn/${mdn}/details?searchType=${searchType}`)
                    .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
            });
        }
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/account/${mdn}/details`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getAccountBuckets(mdn) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/account/${mdn}/buckets`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getUsageHistory(mdn, pageSize, page, sort, sortDirection) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/account/${mdn}/usage?pageSize=${pageSize}&page=${page}&sort=${sort}:${sortDirection}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    activatePlan(planId, body, recaptchaResponse, action, invisibleRecaptcha) {
        let header = new HttpHeaders()
            .set('reCaptcha', recaptchaResponse);
        if (!!action) {
            header = header.set('action', action);
        }
        header = header.set('invisibleRecaptcha', `${!!invisibleRecaptcha}`);
        return new Promise((resolve, reject) => {
            this.http.postWithHeader(`${this.endpointUrl}/v1/plan/${planId}/activate`, body, header)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getDefaultPayment() {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/account/default-payment`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    cancelUserPlan(mdn, planId, immediately = false) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.endpointUrl}/v1/account/${mdn}/plan/${planId}?immediately=${immediately}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    enable5G(mdn, data) {
        return new Promise((resolve, reject) => {
            this.http.put(`${this.endpointUrl}/v1/account/${mdn}/tech5G`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    disable5G(mdn) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.endpointUrl}/v1/account/${mdn}/tech5G`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    checkMdnExists(mdn, recaptchaResponse, action, invisibleRecaptcha) {
        let header = new HttpHeaders()
            .set('reCaptcha', recaptchaResponse);
        if (!!action) {
            header = header.set('action', action);
        }
        header = header.set('invisibleRecaptcha', `${!!invisibleRecaptcha}`);
        return new Promise((resolve, reject) => {
            this.http.getWithOptions(`${this.endpointUrl}/v1/account/mdn/check/${mdn}`, '', header)
                .pipe(take(1)).subscribe((account) => resolve(account), (error) => reject(error));
        });
    }
    addActivatedMdn(mdn) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.endpointUrl}/v1/plan/add-activated-mdn?mdn=${mdn}`, {})
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    reverseCancelPlan(mdn, planId) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.endpointUrl}/v1/account/canceledOnExpiry/${mdn}/plan/${planId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: UserAccountService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: UserAccountService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: UserAccountService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class UserProfileService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
    }
    getUserProfile() {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/profile`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    changePassword(data) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.endpointUrl}/v1/auth/change-password`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    addShippingAddress(data) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.endpointUrl}/v1/profile/shipping-addresses`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    editShippingAddress(shippingAddressId, data) {
        return new Promise((resolve, reject) => {
            this.http.put(`${this.endpointUrl}/v1/profile/shipping-addresses/${shippingAddressId}`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getShippingAddressByID(shippingAddressId) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/profile/shipping-addresses/${shippingAddressId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    deleteShippingAddress(addressId) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.endpointUrl}/v1/profile/shipping-addresses/${addressId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    addPaymentMethod(data, recaptchaResponse, action, invisibleRecaptcha) {
        let header = new HttpHeaders()
            .set('reCaptcha', recaptchaResponse);
        if (!!action) {
            header = header.set('action', action);
        }
        header = header.set('invisibleRecaptcha', `${!!invisibleRecaptcha}`);
        return new Promise((resolve, reject) => {
            this.http.postWithHeader(`${this.endpointUrl}/v1/profile/payment-methods`, data, header)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    editPaymentMethod(paymentId, data, recaptchaResponse, action, invisibleRecaptcha) {
        let header = new HttpHeaders()
            .set('reCaptcha', recaptchaResponse);
        if (!!action) {
            header = header.set('action', action);
        }
        header = header.set('invisibleRecaptcha', `${!!invisibleRecaptcha}`);
        return new Promise((resolve, reject) => {
            this.http.put(`${this.endpointUrl}/v1/profile/payment-methods/${paymentId}`, data, header)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    deletePaymentMethod(paymentId) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.endpointUrl}/v1/profile/payment-methods/${paymentId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    editUserProfile(data) {
        return new Promise((resolve, reject) => {
            this.http.patch(`${this.endpointUrl}/v1/profile`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getPaymentMethods() {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/profile/payment-methods`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getPaymentMethod(id) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/profile/payment-methods/${id}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getShippingAddresses() {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/profile/shipping-addresses`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    sendVerificationEmail(userEmail) {
        const data = { "email": userEmail };
        return new Promise((resolve, reject) => {
            this.http.post(`${this.endpointUrl}/v1/verify`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: UserProfileService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: UserProfileService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: UserProfileService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class CartService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
        this.userCartSubject = new ReplaySubject(1);
        this.CART_V1_URL = `${this.endpointUrl}/v1/cart`;
        this.CART_V2_URL = `${this.endpointUrl}/v2/cart`;
        this.userCart = this.userCartSubject.asObservable().pipe(debounceTime(50));
    }
    resetCartObservable() {
        this.userCartSubject.next(undefined);
    }
    updateCartObservable(cart) {
        this.userCartSubject.next(cart);
    }
    /**
     * a method to get user cart details
     * @returns all cart items (new,mdn)
     */
    getUserCart() {
        return new Promise((resolve, reject) => {
            this.http.get(this.CART_V1_URL).pipe(take(1)).subscribe((data) => {
                resolve(data);
            }, (error) => reject(error));
        });
    }
    /**
     * a method to set user cart details in firebase
     * @returns all cart items (new,mdn)
     */
    setUserCartInFirebase(cart) {
        return new Promise((resolve, reject) => {
            this.http.post(this.CART_V2_URL, cart).pipe(take(1)).subscribe((data) => {
                resolve(data);
            }, (error) => reject(error));
        });
    }
    /**
    * a method to update user cart details in firebase
    * @returns all cart items (new,mdn)
    */
    updateUserCartInFirebase(cart) {
        return new Promise((resolve, reject) => {
            this.http.patch(this.CART_V2_URL, cart).pipe(take(1)).subscribe((data) => {
                resolve(data);
            }, (error) => reject(error));
        });
    }
    /**
     * a method to get user cart details from firebase
     * @returns all cart items (new,mdn)
     */
    getUserCartFromFirebase() {
        return new Promise((resolve, reject) => {
            this.http.get(this.CART_V2_URL).pipe(take(1)).subscribe((data) => {
                this.userCartSubject.next(data);
                resolve(data);
            }, (error) => reject(error));
        });
    }
    /**
     * a method to add item to the user's new cart
     * @returns user cart with added items
     */
    addNewItemToCart(newCart) {
        return new Promise((resolve, reject) => {
            this.http.put(`${this.CART_V1_URL}/items`, newCart).pipe(take(1)).subscribe((data) => {
                resolve(data);
            }, (error) => reject(error));
        });
    }
    /**
     * a method to add item to the user's new cart
     * @returns user cart with added items
     */
    addMdnItemToCart(newCart, mdn) {
        return new Promise((resolve, reject) => {
            this.http.put(`${this.CART_V1_URL}/items/${mdn}`, newCart).pipe(take(1)).subscribe((data) => {
                resolve(data);
            }, (error) => reject(error));
        });
    }
    /**
     * a method to delete user cart
     * @returns void
     */
    deleteUserCart() {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.CART_V1_URL}`).pipe(take(1)).subscribe((data) => {
                resolve(data);
            }, (error) => reject(error));
        });
    }
    /**
     * a method to delete user cart
     * @returns void
     */
    deleteUserCartFromFirebase() {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.CART_V2_URL}`).pipe(take(1)).subscribe((data) => {
                this.userCartSubject.next(null);
                resolve(data);
            }, (error) => reject(error));
        });
    }
    /**
     * a method to delete item by id from user cart
     * @returns void
     */
    deleteItemById(itemId) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.CART_V1_URL}/items/${itemId}`).pipe(take(1)).subscribe((data) => {
                resolve(data);
            }, (error) => reject(error));
        });
    }
    /**
     * a method to delete mdn item by id from user cart
     * @returns void
     */
    deleteMdnItemById(mdn, itemId) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.CART_V1_URL}/${mdn}/items/${itemId}`).pipe(take(1)).subscribe((data) => {
                resolve(data);
            }, (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CartService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CartService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CartService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class AuthenticationService {
    constructor(endpointUrl, http, httpClient) {
        this.endpointUrl = endpointUrl;
        this.http = http;
        this.httpClient = httpClient;
        this.AUTH_V1_URL = `${this.endpointUrl}/v1/auth`;
    }
    login(userEmail, pass) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.AUTH_V1_URL}/login`, { email: userEmail, password: pass })
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    logout() {
        return new Promise((resolve, reject) => {
            this.http.putWithResponseText(`${this.AUTH_V1_URL}/logout`, {})
                .pipe(take(1)).subscribe(() => resolve(), (error) => reject(error));
        });
    }
    signup(userInfo) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.AUTH_V1_URL}/signup`, userInfo)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthenticationService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }, { token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthenticationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AuthenticationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }, { type: i1$1.HttpClient }] });

class OrdersService {
    constructor(endpointUrl, http, aHttp) {
        this.endpointUrl = endpointUrl;
        this.http = http;
        this.aHttp = aHttp;
        this.SHOP_V1_URL = `${this.endpointUrl}/v1/shop`;
        this.ORDER_V1_URL = `${this.endpointUrl}/v1/orders`;
    }
    /**
     * a method to purchase order for user cart
     * @returns order id
     */
    purchaseOrder(purchaseDetails, mdn) {
        const url = !!mdn ? `${this.SHOP_V1_URL}/checkout?mdn=${mdn}` : `${this.SHOP_V1_URL}/checkout`;
        return new Promise((resolve, reject) => {
            this.http.patch(url, purchaseDetails, { withCredentials: true }).pipe(take(1)).subscribe((result) => {
                resolve(result);
            }, (error) => reject(error));
        });
    }
    placeOrder(cart) {
        return new Promise((resolve, reject) => {
            this.aHttp.post(`${this.ORDER_V1_URL}`, cart)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    changePlan(data) {
        return new Promise((resolve, reject) => {
            this.aHttp.post(`${this.ORDER_V1_URL}/plan`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    refillPlan(data) {
        return new Promise((resolve, reject) => {
            this.aHttp.post(`${this.ORDER_V1_URL}/plan/refill`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    orderAddon(planId, data) {
        return new Promise((resolve, reject) => {
            this.aHttp.post(`${this.ORDER_V1_URL}/plan/${planId}/addon`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    orderReplacementSim(data) {
        return new Promise((resolve, reject) => {
            this.aHttp.post(`${this.ORDER_V1_URL}/sim`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    orderAddonReplacementSim(planId, data) {
        return new Promise((resolve, reject) => {
            this.aHttp.post(`${this.ORDER_V1_URL}/plan/${planId}/items`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getOrderReceipt(orderId) {
        return new Promise((resolve, reject) => {
            this.aHttp.get(`${this.ORDER_V1_URL}/${orderId}/invoice`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getPaidOrderReceipt(orderId, view) {
        return new Promise((resolve, reject) => {
            this.aHttp.get(`${this.ORDER_V1_URL}/${orderId}/receipt?&view=${view}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    deleteOrderBydId(orderId, refund, reason) {
        let queryParams;
        if (!!refund) {
            queryParams = `refund=${refund}`;
        }
        if (!!reason) {
            queryParams = `${queryParams}&reason=${reason}`;
        }
        if (!!queryParams) {
            return new Promise((resolve, reject) => {
                this.aHttp.delete(`${this.ORDER_V1_URL}/${orderId}?${queryParams}`)
                    .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
            });
        }
        return new Promise((resolve, reject) => {
            this.aHttp.delete(`${this.ORDER_V1_URL}/${orderId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    validateItemExistance(id) {
        return new Promise((resolve, reject) => {
            this.aHttp.get(`${this.ORDER_V1_URL}/fulfillment/items/${id}/validate`, { withCredentials: true })
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getOrderById(orderId) {
        return new Promise((resolve, reject) => {
            this.aHttp.get(`${this.ORDER_V1_URL}/${orderId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    filterOrders(filterBody) {
        return new Promise((resolve, reject) => {
            this.aHttp.post(`${this.ORDER_V1_URL}/filter`, filterBody)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getOrders(filter, page, pageSize) {
        let queryParams = `filter=${filter}&page=${page}&pageSize=${pageSize}`;
        return new Promise((resolve, reject) => {
            this.aHttp.get(`${this.ORDER_V1_URL}?${queryParams}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    updateOrderShippingAddress(body) {
        return new Promise((resolve, reject) => {
            this.aHttp.put(`${this.ORDER_V1_URL}/shippingAddress`, body)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    makeDeferredPayment(orderId, data) {
        return new Promise((resolve, reject) => {
            this.aHttp.post(`${this.ORDER_V1_URL}/${orderId}/deferred`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getOrderTrackingDetails(orderId) {
        return new Promise((resolve, reject) => {
            this.aHttp.get(`${this.ORDER_V1_URL}/${orderId}/tracking`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getOrderPaymentHistory(orderId) {
        return new Promise((resolve, reject) => {
            this.aHttp.get(`${this.ORDER_V1_URL}/${orderId}/history`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OrdersService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1$1.HttpClient }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OrdersService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OrdersService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1$1.HttpClient }, { type: i1.AuthHttp }] });

class IccidService {
    constructor(endpointUrl, http, sanitizer) {
        this.endpointUrl = endpointUrl;
        this.http = http;
        this.sanitizer = sanitizer;
    }
    getQrCode(iccid, planId) {
        return this.http
            .getMedia(`${this.endpointUrl}/v1/iccid/${iccid}?planId=${planId}`)
            .pipe(map((item) => {
            const urlToBlob = window.URL.createObjectURL(item); // get a URL for the blob
            return this.sanitizer.bypassSecurityTrustResourceUrl(urlToBlob); // tell Anuglar to trust this value
        }));
    }
    getIccidCounts() {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/iccids/count`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IccidService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }, { token: i2$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IccidService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IccidService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }, { type: i2$1.DomSanitizer }] });

class LookupsService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
        this.LOOKUPS_V1_URL = `${this.endpointUrl}/v1/lookup/stores`;
    }
    getAvailableStores() {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.LOOKUPS_V1_URL}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LookupsService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LookupsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LookupsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1$1.HttpClient }] });

class VoucherService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
        this.VOUCHER_V1_URL = `${this.endpointUrl}/v1/voucher`;
    }
    validateVoucher(data) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.VOUCHER_V1_URL}/code-validation`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VoucherService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VoucherService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VoucherService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class SupportService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
    }
    createTicket(body) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.endpointUrl}/v1/support/tickets`, body)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    sendContactUsData(body, invisibleRecaptchaToken, action) {
        let header = new HttpHeaders()
            .set('reCaptcha', invisibleRecaptchaToken);
        if (!!action) {
            header = header.set('action', action);
        }
        header = header.set('invisibleRecaptcha', `true`);
        return new Promise((resolve, reject) => {
            this.http.postWithHeader(`${this.endpointUrl}/v1/support/contact-us`, body, header)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SupportService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SupportService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SupportService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class FuturePayService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
        this.FP_PROVIDER = 'payTomorrow';
        this.FUTUREPAY_V1_URL = `${this.endpointUrl}/v1/payments/financing`;
        this.FUTUREPAY_V1_STATUS_URL = `${this.endpointUrl}/v1/finance/${this.FP_PROVIDER}/applications`;
    }
    /**
     * a method to create order token
     * @returns order token
     */
    createOrderToken(purchaseDetails) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.FUTUREPAY_V1_URL}`, purchaseDetails).pipe(take(1)).subscribe((result) => {
                resolve(result);
            }, (error) => reject(error));
        });
    }
    /**
     * a method to create a new order token with FuturePay
     * @returns order token that is used in IFrame url
     */
    startApplication(shippingDetails) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.FUTUREPAY_V1_STATUS_URL}`, shippingDetails).pipe(take(1)).subscribe((result) => {
                resolve(result);
            }, (error) => reject(error));
        });
    }
    /**
     * a method to get the status of an order from FuturePay
     * @returns Order status
     */
    getApplicationStatus(applicationId) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.FUTUREPAY_V1_STATUS_URL}/${applicationId}`).pipe(take(1)).subscribe((result) => {
                resolve(result);
            }, (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FuturePayService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FuturePayService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FuturePayService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class TaxesService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
    }
    calculateTaxes(city, state, autoRenewPlan, balanceAmount, rewardsAmount, voucherCode) {
        let queryParams = `?city=${city}&state=${state}&autoRenewPlan=${autoRenewPlan}`;
        if (!!balanceAmount && balanceAmount > 0) {
            queryParams = `${queryParams}&balanceAmount=${balanceAmount}`;
        }
        if (!!rewardsAmount && rewardsAmount > 0) {
            queryParams = `${queryParams}&rewardsAmount=${rewardsAmount}`;
        }
        if (!!voucherCode) {
            queryParams = `${queryParams}&voucherCode=${voucherCode}`;
        }
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/taxes${queryParams}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    calculateEstimateTaxes(postalCode, autoRenewPlan) {
        let queryParams = `?postalCode=${postalCode}&autoRenewPlan=${autoRenewPlan}`;
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/taxes/estimate${queryParams}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TaxesService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TaxesService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TaxesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class PaymentsService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
    }
    createPaymentProfile(paymentProfile) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.endpointUrl}/v1/payment/profile`, paymentProfile)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getPaymentProfiles(accountId, mdn) {
        let queryParams = `accountId=${accountId}`;
        if (!!mdn) {
            queryParams = `${queryParams}&mdn=${mdn}`;
        }
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/payment/profiles?${queryParams}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getPaymentProfile(profileId) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/payment/profile/${profileId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    deletePaymentProfile(profileId) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.endpointUrl}/v1/payment/profile/${profileId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    editPaymentProfile(profileId, body) {
        return new Promise((resolve, reject) => {
            this.http.patch(`${this.endpointUrl}/v1/payment/profile/${profileId}`, body)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getPaymentHistory(page, pageSize, mdn) {
        let params = `page=${page}&pageSize=${pageSize}`;
        if (!!mdn) {
            params = `${params}&mdn=${mdn}`;
        }
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/payment/payment-history?${params}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    UpdateProfileDefaultPayment(body) {
        return new Promise((resolve, reject) => {
            this.http.put(`${this.endpointUrl}/v1/payment/profile/default`, body)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getAccountDefaultPaymentProfile() {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/payment/profile/default`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaymentsService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaymentsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaymentsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class KountService {
    constructor() {
    }
    initializeKountSdk(clientId, environment) {
        const sessionID = this.generateSessionID();
        const kountConfig = {
            clientID: clientId,
            environment: environment,
            isSinglePageApp: true,
            isDebugEnabled: true,
        };
        kountSDK(kountConfig, sessionID);
        return sessionID;
    }
    generateSessionID() {
        const length = 32; // Desired length of the session ID
        // Generate a UUID (removing dashes to make it compact)
        let uuid = v4().replace(/-/g, '');
        // Get the current timestamp in "yyyyMMddHHmmssSSS" format
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const date = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
        const timestamp = `${year}${month}${date}${hours}${minutes}${seconds}${milliseconds}`;
        // Combine the UUID and timestamp, truncating if necessary to fit the required length
        const sessionID = (uuid + timestamp).substring(0, length);
        return sessionID;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: KountService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: KountService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: KountService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class PortinService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
    }
    getPortinDetails(planId) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/plan/${planId}/portin`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    submitPortinRequest(planId, data, recaptchaResponse) {
        return new Promise((resolve, reject) => {
            const header = new HttpHeaders().set('reCaptcha', recaptchaResponse);
            this.http.postWithHeader(`${this.endpointUrl}/v1/plan/${planId}/portin`, data, header)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    cancelPortinRequest(planId) {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.endpointUrl}/v1/plan/${planId}/portin`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PortinService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PortinService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PortinService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class ReferralService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
    }
    setReferralMdn(selectedMdn) {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.endpointUrl}/api/referral`, { mdn: selectedMdn })
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getReferralDetails(limit, page) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/api/referral?limit=${limit}&page=${page}`)
                .subscribe((response) => resolve(response), (error) => reject(error));
        });
    }
    getUserReferralDetails(limit, page) {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/api/referral/accepted?limit=${limit}&page=${page}`)
                .subscribe((response) => resolve(response), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReferralService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReferralService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReferralService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class BackendV2Module {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BackendV2Module, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: BackendV2Module }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BackendV2Module, providers: [CatalogCoreService, EbbService, EquipmentService, NewsletterService, OrdersService,
            ShipmentService, SweepstakesService, UserAccountService, UserProfileService, CartService,
            AuthenticationService, DeviceDetectorService, IccidService, LookupsService,
            VoucherService, SupportService, FuturePayService, TaxesService, PaymentsService,
            KountService, PortinService, ReferralService] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BackendV2Module, decorators: [{
            type: NgModule,
            args: [{
                    providers: [CatalogCoreService, EbbService, EquipmentService, NewsletterService, OrdersService,
                        ShipmentService, SweepstakesService, UserAccountService, UserProfileService, CartService,
                        AuthenticationService, DeviceDetectorService, IccidService, LookupsService,
                        VoucherService, SupportService, FuturePayService, TaxesService, PaymentsService,
                        KountService, PortinService, ReferralService]
                }]
        }] });

const CATALOG_INTENT = {
    NEW: 'newPurchase',
    CHANGE: 'changePlan'
};

class ProductPlansService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
    }
    getPlanUniqueIdentifier(ratePlanId) {
        let queryParams = ``;
        if (!!ratePlanId) {
            queryParams = `ratePlan=${ratePlanId}`;
        }
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/v1/product-plans/info?${queryParams}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProductPlansService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProductPlansService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProductPlansService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class ProfileService {
    constructor(endpointUrl, http) {
        this.endpointUrl = endpointUrl;
        this.http = http;
    }
    getUserProfile(version = 'v2') {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/${version}/profile`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    updateUserProfile(version = 'v2', data) {
        return new Promise((resolve, reject) => {
            this.http.patch(`${this.endpointUrl}/${version}/profile`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    deleteShippingAddress(addressId, version = 'v1') {
        return new Promise((resolve, reject) => {
            this.http.delete(`${this.endpointUrl}/${version}/profile/shipping-addresses/${addressId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    addShippingAddress(data, version = 'v1') {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.endpointUrl}/${version}/profile/shipping-addresses`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    editShippingAddress(shippingAddressId, data, version = 'v1') {
        return new Promise((resolve, reject) => {
            this.http.put(`${this.endpointUrl}/${version}/profile/shipping-addresses/${shippingAddressId}`, data)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    getShippingAddressById(shippingAddressId, version = 'v1') {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.endpointUrl}/${version}/profile/shipping-addresses/${shippingAddressId}`)
                .pipe(take(1)).subscribe((result) => resolve(result), (error) => reject(error));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProfileService, deps: [{ token: ZMP_G2G_BFF_ENDPOINT_URL }, { token: i1.AuthHttp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProfileService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProfileService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ZMP_G2G_BFF_ENDPOINT_URL]
                }] }, { type: i1.AuthHttp }] });

class AddressMap {
    constructor() {
    }
    mapUserAddress(addresses) {
        return addresses?.map((addressDetails) => {
            if (!!addressDetails) {
                const country = this.getAddressComponentByType(addressDetails?.components, 'country', true);
                let state = this.getAddressComponentByType(addressDetails?.components, 'administrative_area_level_1', true);
                if (country === 'PR') { // Puerto Rico
                    state = country;
                }
                let city = this.getAddressComponentByType(addressDetails?.components, 'locality');
                if (city === '') { // Look for 'sublocality' if 'locality' is empty
                    city = this.getAddressComponentByType(addressDetails?.components, 'sublocality');
                }
                const address2 = this.getAddressComponentByType(addressDetails?.components, 'secondary_unit_designator');
                const fullStreet = (this.getAddressComponentByType(addressDetails?.components, 'street_number', true) + ' ' + this.getAddressComponentByType(addressDetails?.components, 'route', true)).trim();
                // Map to IFirebaseAddress
                const firebaseAddress = {
                    id: addressDetails?.id,
                    alias: addressDetails?.alias || '',
                    createdAt: new Date(addressDetails.createdAt).getTime(),
                    isDefault: false,
                    address1: fullStreet,
                    address2: !!address2 ? address2 : '',
                    country: country || '',
                    city: city || '',
                    state: state || '',
                    postalCode: this.getAddressComponentByType(addressDetails?.components, 'postal_code', true) || '',
                    name: addressDetails?.name || '',
                    main_text: `${fullStreet}, ${city}, ${state} ${this.getAddressComponentByType(addressDetails?.components, 'postal_code', true)}`
                };
                return firebaseAddress;
            }
            return null;
        }).filter(Boolean); // Filter out null values
    }
    mapToAddressComponents(address) {
        const components = [];
        if (address?.address1) {
            const [streetNumber, ...routeParts] = address.address1.split(' ');
            components.push({
                types: ['street_number'],
                shortName: streetNumber,
                longName: streetNumber
            }, {
                types: ['route'],
                shortName: routeParts.join(' '),
                longName: routeParts.join(' ')
            });
        }
        if (address?.address2) {
            components.push({
                types: ['secondary_unit_designator'],
                shortName: address.address2,
                longName: address.address2
            });
        }
        if (address?.city) {
            components.push({
                types: ['locality'],
                shortName: address.city,
                longName: address.city
            });
        }
        if (address?.state) {
            components.push({
                types: ['administrative_area_level_1'],
                shortName: address.state,
                longName: address.state
            });
        }
        if (address?.postalCode) {
            components.push({
                types: ['postal_code'],
                shortName: address.postalCode,
                longName: address.postalCode
            });
        }
        if (address?.country) {
            components.push({
                types: ['country'],
                shortName: address.country,
                longName: address.country
            });
        }
        return components;
    }
    getAddressComponentByType(addressComponents, type, short) {
        let selectedComponentText = '';
        const selectedComponent = addressComponents.find((ac) => ac.types.indexOf(type) !== -1);
        if (!!selectedComponent) {
            if (short) {
                selectedComponentText = selectedComponent.shortName;
            }
            else {
                selectedComponentText = selectedComponent.longName;
            }
        }
        else {
            selectedComponentText = ''; // Failed to find
        }
        return selectedComponentText;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AddressMap, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AddressMap, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AddressMap, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

/*
 * Public API Surface of backend-v2
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddressMap, AuthenticationService, BackendV2Module, CATALOG_INTENT, CartService, CatalogCoreService, EbbService, EquipmentService, FuturePayService, IccidService, KountService, LookupsService, NewsletterService, OrdersService, PaymentsService, PortinService, ProductPlansService, ProfileService, ReferralService, ShipmentService, SupportService, SweepstakesService, TaxesService, UserAccountService, UserProfileService, VoucherService };
